import { ExternalIcon } from "@icons/ExternalIcon";
import { colors } from "@ui-kit/ConfigProvider/ConfigProvider";
import { TabButton } from "@ui-kit/TabButton/TabButton";
import { useTranslation } from "react-i18next";

interface MapOverlayButtonProps {
  onPress: () => void;
}

const MapOverlayButton = ({ onPress }: MapOverlayButtonProps) => {
  const { t } = useTranslation();
  return (
    <TabButton
      onPress={onPress}
      label={t("common.map")}
      active={true}
      size="large"
      bigButton={true}
      iconPrefix={<ExternalIcon size={18} color={colors.white} svgName="map" />}
    />
  );
};

export { MapOverlayButton };
